import React, { useState, useEffect } from "react";
import PageBanner from "../components/PageBanner";
import { HERO_IMAGES } from "../mock";
import { fetchCars } from "../api";

const Sold = () => {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    fetchCars({ status: "sold" }).then(setCars).catch(() => setCars([]));
  }, []);

  return (
    <div className="bg-white">
      <PageBanner title="Recently Sold" subtitle="A glimpse of the exceptional motorcars that have found new homes through GPM Classics." image={HERO_IMAGES[0]} />
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {cars.map((c) => (
            <div key={c.id} className="group bg-white border border-black/10 overflow-hidden">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img src={c.images[0]} alt={c.title} className="w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 transition-all duration-500" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-white font-serif-display text-3xl font-bold px-6 py-2 border-2 border-white -rotate-6" style={{ background: "rgba(122,32,32,0.75)" }}>SOLD</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-serif-display text-xl font-semibold gpm-text-green">{c.title}</h3>
                <p className="text-sm text-gray-500 mt-1">{c.year}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sold;
